import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, breakpoint, duration, size } from '@twisto/styles'

export const root = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: ${size[48]};
  padding: ${size[8]} ${size[16]};
  color: ${theme.palette.neutral[900]};
  border-radius: ${borderRadius.sm};
  background-color: ${theme.palette.neutral[100]};
  font-weight: 500;
  border: 2px solid transparent;
  margin: ${size[8]} 0;
  transition:
    background-color ${duration.standard}ms,
    border-color ${duration.shorter}ms;

  ${breakpoint.up('sm')} {
    margin: ${size[16]} 0;
  }

  &:hover {
    background: ${theme.palette.neutral[200]};
  }

  &:focus {
    outline: 2px solid ${theme.palette.brand[200]};
    outline-offset: 2px;
  }
`

export const active = (theme: Theme) => css`
  border: 2px solid ${theme.palette.brand[500]};
  outline: 2px solid ${theme.palette.brand[100]};

  // in case the element is focused by click (not tab) use the default outline
  &:focus:not(:focus-visible) {
    outline-offset: 0;
  }
`

export const disabled = (theme: Theme) => css`
  background-color: ${theme.palette.background.secondary};
  color: ${theme.palette.neutral[600]};
  pointer-events: none;
`

export const types = {
  /* Styles applied to the root element if `type="default"`. */
  default: css`
    cursor: default;
  `,
  /* Styles applied to the root element if `type="link"`. */
  link: css`
    cursor: pointer;
    text-decoration: none;
  `,
}

export const clickable = css`
  cursor: pointer;
`
